import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './Grid.module.css';

export type GridProps = ComponentProps<'div'>;

export const Grid: FunctionComponent<GridProps> = React.memo((props) => {
  const { children, className, ...remainingProps } = prepareProps({ props });

  return (
    <div
      {...remainingProps}
      className={classes(className, styles.container)}
    >
      {children}
    </div>
  );
});
